import React from 'react';

import { bemBlock } from '@neptune/shared/venus-ui';

import './TokenRenderer.less';

const block = bemBlock('syntax-token');

export const TokenRenderer = ({
  className,
  tokenType,
  'data-role': dataRole,
  children,
}: {
  className?: string;
  tokenType: string;
  darkMode?: boolean;
  'data-role'?: string;
  children?: React.ReactNode;
}) => {
  return (
    <span
      className={block({ modifiers: { [tokenType]: true }, extra: className })}
      data-role={dataRole}
      data-heap-redact-text
    >
      {children}
    </span>
  );
};
